import ImagesAuthLayoutBgWebp from '@/public/images/auth-layout/bg.webp';

export { ImagesAuthLayoutBgWebp };
